module.exports = __webpack_public_path__ + "static/media/ninetenth.4c50310f.png";